import { cardBrandIconsMap } from 'components/icons/cardBrandIcons'

export const cards_brands = [
  { value: 'visa', label: 'VISA', icon: cardBrandIconsMap.VISA },
  { value: 'mastercard', label: 'MASTERCARD', icon: cardBrandIconsMap.MC },
  { value: 'amex', label: 'AMEX', icon: cardBrandIconsMap.AMEX },
  { value: 'discover', label: 'DISCOVER', icon: cardBrandIconsMap.DISC },
  {
    value: 'dinersclub',
    label: 'DINERSCLUB',
    icon: cardBrandIconsMap.DINERSCLUB,
  },
  { value: 'jcb', label: 'JCB', icon: cardBrandIconsMap.JCB },
  { value: 'maestro', label: 'MAESTRO', icon: cardBrandIconsMap.MAESTRO },
  { value: 'applepay', label: 'APPLEPAY', icon: cardBrandIconsMap.APPLEPAY },
  { value: 'googlepay', label: 'GOOGLEPAY', icon: cardBrandIconsMap.GOOGLEPAY },
]

export const FETCH_REVENUE_CENTERS_LIMIT = 10
